import constants from '../_constants/admin.constants';

const INITIAL_STATE = {
  billingOverview: {},
  isLoadingBillingOverview: false,
};

export function admin(state = INITIAL_STATE, action) {
  switch (action.type) {
    case constants.BILLING_OVERVIEW_FETCH_REQUEST:
      return {
        ...state,
        isLoadingBillingOverview: true,
      };
    case constants.BILLING_OVERVIEW_FETCH_SUCCESS:
      return {
        ...state,
        billingOverview: action.payload,
        isLoadingBillingOverview: false,
      };
    case constants.BILLING_OVERVIEW_FETCH_FAILURE:
      return {
        ...state,
        isLoadingBillingOverview: false,
      };
    default:
      return state;
  }
}
